import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TextStyle = /*#__PURE__*/function () {
  function TextStyle(props) {
    _classCallCheck(this, TextStyle);

    this.props = props;
    this.props = props;
  }

  _createClass(TextStyle, [{
    key: "styles",
    value: function styles() {
      var outStyles = {
        fontFamily: this.props.fontFamily,
        fontSize: this.props.fontSize,
        fontWeight: this.props.fontWeight,
        fontStyle: this.props.fontStyle,
        lineHeight: this.props.lineHeight,
        letterSpacing: this.props.letterSpacing
      };

      if (this.props.textDecoration) {
        var _this$props$textDecor;

        outStyles.textDecoration = (_this$props$textDecor = this.props.textDecoration) === null || _this$props$textDecor === void 0 ? void 0 : _this$props$textDecor.join(' ');
      }

      return outStyles;
    }
  }, {
    key: "noLineHeight",
    value: function noLineHeight() {
      return new TextStyle(_objectSpread(_objectSpread({}, this.props), {}, {
        lineHeight: undefined
      }));
    }
  }, {
    key: "fontFamily",
    get: function get() {
      return this.props.fontFamily;
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this.props.fontSize;
    }
  }, {
    key: "fontWeight",
    get: function get() {
      return this.props.fontWeight;
    }
  }, {
    key: "fontStyle",
    get: function get() {
      return this.props.fontStyle;
    }
  }, {
    key: "lineHeight",
    get: function get() {
      return this.props.lineHeight;
    }
  }, {
    key: "letterSpacing",
    get: function get() {
      return this.props.letterSpacing;
    }
  }, {
    key: "textDecoration",
    get: function get() {
      var _this$props$textDecor2;

      return (_this$props$textDecor2 = this.props.textDecoration) === null || _this$props$textDecor2 === void 0 ? void 0 : _this$props$textDecor2.join(' ');
    }
  }]);

  return TextStyle;
}();

export { TextStyle as default };
//# sourceMappingURL=TextStyle.js.map